module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "mt-2 d-flex"
  }, [_c('button', {
    staticClass: "btn tertiary full super mr-3",
    class: {
      'blue': _vm.invoiceTo == 'customer'
    },
    attrs: {
      "disabled": true
    },
    on: {
      "click": function($event) {
        return _vm.setInvoiceTo('customer')
      }
    }
  }, [_vm._v("Customer (coming soon)")]), _vm._v(" "), _c('button', {
    staticClass: "btn tertiary full super",
    class: {
      'blue': _vm.invoiceTo == 'agent'
    },
    on: {
      "click": function($event) {
        return _vm.setInvoiceTo('agent')
      }
    }
  }, [_vm._v("Agent")])]), _vm._v(" "), (_vm.invoiceTo) ? _c('div', {
    staticClass: "mt-2 d-flex justify-content-between"
  }, [_c('div', [(_vm.invoiceTo == 'agent') ? _c('seller-picker', {
    attrs: {
      "changeReservationSeller": false,
      "showMyTeam": false,
      "inlcudeWidget": false
    },
    on: {
      "input": _vm.sellerChanged
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.invoiceResumeBulk) ? _c('div', [_c('label', [_vm._v("\n                    Amount to invoice\n                ")]), _vm._v(" "), (_vm.getIsDownloadingInvoiceResumeBulk) ? _c('div', [_c('loader')], 1) : _c('div', {
    staticClass: "fs-large text-right darker bold"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.valueToInvoice)) + "€")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.invoiceTo) ? _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    class: {
      'color-6': _vm.$v.invoiceToForm.vat.$invalid
    }
  }, [_vm._v("\n                    VAT Number\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceToForm.vat),
      expression: "invoiceToForm.vat"
    }],
    staticClass: "full mb-3",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.invoiceToForm.vat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceToForm, "vat", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    class: {
      'color-6': _vm.$v.invoiceToForm.city.$invalid
    }
  }, [_vm._v("\n                    City "), (_vm.isInvoiceValueOver) ? _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceToForm.city),
      expression: "invoiceToForm.city"
    }],
    staticClass: "full mb-3",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.invoiceToForm.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceToForm, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    class: {
      'color-6': _vm.$v.invoiceToForm.country.$invalid
    }
  }, [_vm._v("\n                    Country "), (_vm.isInvoiceValueOver) ? _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.getCountries,
      "placeholder": "Select Country",
      "label": "name"
    },
    on: {
      "input": _vm.selectedCountryChanged
    },
    model: {
      value: (_vm.selectedCountry),
      callback: function($$v) {
        _vm.selectedCountry = $$v
      },
      expression: "selectedCountry"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    class: {
      'color-6': _vm.$v.invoiceToForm.businessName.$invalid
    }
  }, [_vm._v("\n                    Billing name\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceToForm.businessName),
      expression: "invoiceToForm.businessName"
    }],
    staticClass: "full mb-3",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.invoiceToForm.businessName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceToForm, "businessName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    class: {
      'color-6': _vm.$v.invoiceToForm.address.$invalid
    }
  }, [_vm._v("\n                    Address "), (_vm.isInvoiceValueOver) ? _c('span', {
    staticClass: "color-6"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceToForm.address),
      expression: "invoiceToForm.address"
    }],
    staticClass: "full mb-3",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.invoiceToForm.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceToForm, "address", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.invoiceTo) ? _c('div', {
    staticClass: "d-flex  align-items-center my-3"
  }, [_c('div', {
    staticClass: "flexGrow1 d-flex"
  }, [(_vm.getIsPrintingInvoice) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('loader'), _vm._v(" "), _c('div', [_vm._v("Downloading invoice please wait")])], 1) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn blue widest",
    attrs: {
      "disabled": _vm.getIsCreatingInvoice || _vm.$v.$invalid || _vm.getIsPrintingInvoice
    },
    on: {
      "click": _vm.emitInvoices
    }
  }, [_vm._v("Invoice")])]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-d2ae0e82", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2ae0e82"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationsBulkActions/areaInvoice.vue
// module id = 1284
// module chunks = 0